/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LatestSchoolForum.vue?vue&type=template&id=177f50e0&scoped=true&"
import script from "./LatestSchoolForum.vue?vue&type=script&setup=true&lang=js&"
export * from "./LatestSchoolForum.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./LatestSchoolForum.vue?vue&type=style&index=0&id=177f50e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177f50e0",
  null
  
)

export default component.exports